import { Button, Modal } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import classNames from 'classnames';
import cn from 'classnames';
import moment from 'moment';
import React, { FC, Fragment, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';

import '../../../../../pages/Checkout/index.sass';
import { BasketDialog } from '../../../../BasketDialog';
import { Icon } from '../../../../Icon';
import { OurAddress } from '../../../../OutAddress';
import CheckoutPhoneOrFullName from '../../../../TextField/CheckoutPhoneOrFullName';

import AddAddressModal from './AddAddressModal/AddAddressModal';
import styles from './BottomContent.module.sass';
import { CustomCssDateField } from './CustomCssDateField';

interface IBottomContent {
  activeCity: 'first' | 'second' | 'third';
  tab: boolean;
}
interface PhoneError {
  message: string;
  pattern?: {
    message: string;
    value: RegExp;
  };
  required?: string;
  min?: { message: string; value: number };
  max?: { message: string; value: number };
  minLength?: { message: string; value: number };
  maxLength?: { message: string; value: number };
}
const BottomContent: FC<IBottomContent> = ({ activeCity, tab }) => {
  const { getValues, control, setError } = useFormContext();
  const minDate = moment(new Date());
  //Выбрать дату доставки. Дефолтное значение - сегодняшнее
  const [deliveryDate, setAddDeliveryDate] = useState<any>(new Date());
  const [whereDeliveryVisibleTab, setWhereDeliveryVisibleTab] = useState(true);
  const [isVisibleDeliveryModal, setIsVisibleDeliveryModal] = useState(false);
  const [isAddAddressData, setIsAddAddressData] = useState(false);

  const isAddressDataValue =
    !!getValues('other_recipient_name') &&
    !!getValues('other_recipient_phone') &&
    !!getValues('delivery_address');

  const onVisibleDeliveryTab = (tab: boolean) => {
    setWhereDeliveryVisibleTab(tab);
  };

  const onVisibleDeliveryModal = () => {
    setIsVisibleDeliveryModal((show) => !show);
  };

  const onCloseDeliveryModal = () => {
    if (
      window.confirm(
        'Вы не заполнили обязательные поля. Вы действительно хотите выйти?'
      )
    ) {
      setIsVisibleDeliveryModal(false);
    }
  };

  const onHideDeliveryModal = () => {
    if (isAddressDataValue) {
      setIsVisibleDeliveryModal(false);
    }
    if (!getValues('other_recipient_name')) {
      setError('other_recipient_name', {
        message: 'Некорректный формат ФИО получателя',
      });
    }
    if (!getValues('other_recipient_phone')) {
      setError('other_recipient_phone', {
        message: 'Некорректный формат телефона',
        types: {
          pattern: {
            message: 'Неверный формат телефона',
            value: /^(\+7|8)\s\d{3}\s\d{3}\s\d{2}\s\d{2}$/,
          },
        },
      } as PhoneError);
    }
    if (!getValues('delivery_address')) {
      setError('delivery_address', {
        message: 'Некорректный формат адрес доставки',
      });
    }
  };

  const onAddAddressData = () => {
    if (isAddressDataValue) setIsAddAddressData(true);
  };
  //Показать адрес
  const [showAddress, setShowAddress] = useState(false);
  //Закрыть адрес
  const handleCloseAddress = () => setShowAddress(false);
  //Показать/закрыть окно адреса
  const handleShowAddress = () => setShowAddress(true);
  return (
    <>
      {!tab && (
        <div className={styles.self}>
          <div className={styles.left}>
            <span className={styles.caption}>
              {activeCity === 'first' && 'DAZEL “Технариум”'}
              {activeCity === 'second' && 'Торговый центр'}
              {activeCity === 'third' && 'Склад "DAZEL"'}
            </span>
            <span
              className={classNames(styles.span2, {
                center: activeCity === 'second',
                right: activeCity === 'third',
              })}
            >
              <Icon variant="mapGray" />
              <p>
                {activeCity === 'first' && (
                  <>
                    <span className={styles.first} onClick={handleShowAddress}>
                      ул. Дальзоводская, 4, пав. 310
                    </span>
                    {showAddress && (
                      <OurAddress
                        open={showAddress}
                        handleClose={handleCloseAddress}
                        address="ул. Дальзоводская, 4, пав. 310"
                      >
                        <iframe
                          src="https://yandex.ru/map-widget/v1/?um=constructor%3A685160ebcbd08cdd6fced4352a2da0677b7dad84ab9f5e22966bb3ba8af08660&amp;source=constructor"
                          width="100%"
                          height="500"
                          frameBorder="0"
                        ></iframe>
                      </OurAddress>
                    )}
                  </>
                )}
                {activeCity === 'second' && (
                  <>
                    <span className={styles.second} onClick={handleShowAddress}>
                      ул. Краснознамённая, 212
                    </span>
                    {showAddress && (
                      <OurAddress
                        open={showAddress}
                        handleClose={handleCloseAddress}
                        address="ул. Краснознамённая, 212"
                      >
                        <iframe
                          src="https://yandex.ru/map-widget/v1/?um=constructor%3A9d2ca837684c3f7789adc75e9cfee5851f860a203c87a4fe287051a3b4c2e22e&amp;source=constructor"
                          width="100%"
                          height="500"
                          frameBorder="0"
                        ></iframe>
                      </OurAddress>
                    )}
                  </>
                )}
                {activeCity === 'third' && (
                  <>
                    <span className={styles.third} onClick={handleShowAddress}>
                      ул. Шоссейная, 94в
                    </span>
                    {showAddress && (
                      <OurAddress
                        open={showAddress}
                        handleClose={handleCloseAddress}
                        address="ул. Шоссейная, 94в"
                      >
                        <iframe
                          src="https://yandex.ru/map-widget/v1/?um=constructor%3Af9ea78b3fa2dcef52858cc08eb77c350c45f8303faf4f4e16c8e390f75da1b63&amp;source=constructor"
                          width="100%"
                          height="500"
                          frameBorder="0"
                        ></iframe>
                      </OurAddress>
                    )}
                  </>
                )}
              </p>
            </span>
            <span className={styles.span3}>
              <Icon variant="phoneGray" />
              {activeCity === 'first' && <span>+7 (423) 246-48-64</span>}
              {activeCity === 'second' && <span>+7 (4234) 34-25-16</span>}
              {activeCity === 'third' && <span>+7 (4236) 69-86-75</span>}
            </span>
          </div>
          <div className={styles.right}>
            <div>Пн-Пт с 9:00 до 18:00</div>
            <div>Сб с 9:00 до 15:00</div>
          </div>
        </div>
      )}
      {tab && (
        <div className={styles.deliv}>
          <div className={styles.top}>
            <span className={styles.caption}>Куда доставить заказ?</span>
            <div className={styles.delivGroup}>
              <Controller
                control={control}
                name="other_recipient"
                render={({ field: { onChange, value } }) => (
                  <input
                    id="basket_check_1"
                    className={styles.inpCbx}
                    style={{ display: 'none' }}
                    type="checkbox"
                    value={value}
                    defaultChecked={whereDeliveryVisibleTab}
                    onChange={(e) => {
                      onChange(e.target.checked);
                      onVisibleDeliveryTab(e.target.checked);
                    }}
                  />
                )}
              />
              <label className={styles.cbx} htmlFor="basket_check_1">
                <span>
                  <svg width="11px" height="8px" viewBox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                  </svg>
                </span>
                <span>Я заберу заказ</span>
              </label>
            </div>
          </div>
          <div className={styles.group}>
            <div className={styles.group1}>
              <Controller
                control={control}
                name="delivery_date"
                render={({ field: { onChange, value } }) => (
                  <LocalizationProvider dateAdapter={AdapterDayjs} locale="ru">
                    <DesktopDatePicker
                      value={value}
                      inputFormat="DD.MM.YYYY"
                      onChange={onChange}
                      minDate={minDate}
                      renderInput={(params) => (
                        <CustomCssDateField
                          {...params}
                          className={styles.date}
                        />
                      )}
                    />
                  </LocalizationProvider>
                )}
              />
              <div className={styles.right}>
                <Icon variant="timeGray" />
                <p>Время доставки с 9:00 до 18:00</p>
              </div>
            </div>
            <div className={styles.group2}>
              {whereDeliveryVisibleTab ? (
                <Fragment>
                  {isAddressDataValue && isAddAddressData ? (
                    <div
                      className={styles.wrapper}
                      onClick={onVisibleDeliveryModal}
                    >
                      <div className={styles.item}>
                        <Icon variant="mapGray" />
                        <p className={cn(styles.text, styles.text_1)}>
                          {getValues('delivery_address')}
                        </p>
                      </div>
                      <div className={styles.item}>
                        <Icon variant="nameOrPhone" />
                        <p className={cn(styles.text, styles.text_2)}>
                          {`${getValues('other_recipient_name')}, ${getValues(
                            'other_recipient_phone'
                          )}`}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <Button
                      variant="text"
                      startIcon={<Icon variant="plusOrange" />}
                      className={cn('contact_btn', 'add-address')}
                      onClick={onVisibleDeliveryModal}
                      type="button"
                      sx={{
                        borderRadius: '8px',
                        color: '#FC5808',
                        fontSize: '14px',
                        fontWeight: '500',
                        textTransform: 'none',
                        '&.MuiButton-root:hover': {
                          borderRadius: '8px',
                          color: '#FF9F2F',
                          fontSize: '14px',
                          fontWeight: '500',
                          textTransform: 'none',
                          backgroundColor: '#fff',
                        },
                      }}
                    >
                      <p className={styles.addedAddress}>
                        Добавить адрес доставки
                      </p>
                    </Button>
                  )}
                </Fragment>
              ) : (
                <div className={styles.inp}>
                  <Controller
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <CheckoutPhoneOrFullName
                        onChange={onChange}
                        value={value}
                        name="other_recipient_name"
                        label="ФИО получателя"
                      />
                    )}
                    name="fullName"
                  />
                  <Controller
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <InputMask
                        mask="+7 999 999 99 99"
                        maskChar={null}
                        maskPlaceholder={null}
                        value={value}
                        onChange={onChange}
                        inputMode="tel"
                        width={100}
                      >
                        <CheckoutPhoneOrFullName
                          name="other_recipient_phone"
                          label="Телефон получателя"
                        />
                      </InputMask>
                    )}
                    name="other_recipient_phone"
                  />
                </div>
              )}
            </div>
            <BasketDialog />
            <p className={styles.bottom}>
              При себе иметь наложенный документ удостоверяющий личность или
              физическое наличие банковской карты
            </p>
          </div>
          <Modal
            keepMounted
            onClose={onVisibleDeliveryModal}
            open={isVisibleDeliveryModal}
            closeAfterTransition
          >
            <AddAddressModal
              onClose={onHideDeliveryModal}
              onAddAddressData={onAddAddressData}
              onCloseImg={onCloseDeliveryModal}
            />
          </Modal>
        </div>
      )}
    </>
  );
};

export default BottomContent;
